import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import DividerStack from './DividerStack';
import ClientProvider from './client';
export default createDemo(import.meta.url, DividerStack, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/components/stack/demos/divider/DividerStack.tsx",
    "fileName": "DividerStack.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/system/Box';\nimport Stack from '@mui/system/Stack';\nimport { styled } from '@mui/system';\n\nconst Item = styled('div')(({ theme }) => ({\n  backgroundColor: '#fff',\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  borderRadius: 4,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#262B32',\n  }),\n}));\n\nexport default function DividerStack() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Stack\n        direction=\"row\"\n        divider={\n          <Box\n            component=\"hr\"\n            sx={(theme) => ({\n              border: `1px solid ${'#fff'}`,\n              ...theme.applyStyles('dark', {\n                border: `1px solid ${'#262B32'}`,\n              }),\n            })}\n          />\n        }\n        spacing={2}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Stack>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 39,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/system/Box';\nimport Stack from '@mui/system/Stack';\nimport { styled } from '@mui/system';\n\nconst Item = styled('div')(({ theme }) => ({\n  backgroundColor: '#fff',\n  padding: theme.spacing(1),\n  textAlign: 'center',\n  borderRadius: 4,\n  ...theme.applyStyles('dark', {\n    backgroundColor: '#262B32',\n  }),\n}));\n\nexport default function DividerStack() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Stack\n        direction=\"row\"\n        divider={\n          <Box\n            component=\"hr\"\n            sx={(theme) => ({\n              border: `1px solid ${'#fff'}`,\n              ...theme.applyStyles('dark', {\n                border: `1px solid ${'#262B32'}`,\n              }),\n            })}\n          />\n        }\n        spacing={2}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n      </Stack>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "totalLines": 39,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/system/Box",
      "@mui/system/Stack",
      "@mui/system"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
